import { render, staticRenderFns } from "./UpcomingReviews.vue?vue&type=template&id=5bc38178&scoped=true"
import script from "./UpcomingReviews.vue?vue&type=script&lang=js"
export * from "./UpcomingReviews.vue?vue&type=script&lang=js"
import style0 from "./UpcomingReviews.vue?vue&type=style&index=0&id=5bc38178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc38178",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
